module.exports = __webpack_public_path__ + "static/media/24UHCHR8.47a74d13.jpg";